export const LOADING = 'LOADING'

export const resetLoading = key => {
  return {
    type: LOADING,
    key,
    status: undefined
  }
}
